import {Select, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Controller, useFormContext} from "react-hook-form";
import {LiveEventEventTypeFormFieldsType} from "../../../types";
import {StyledInputValue} from "../../../../../../live-classes/live-classes-form/live-classes-form.style";
import {TIMEOPTIONS} from "../../../../../../../services/timezones";
import {LiveEventEventTypeTopicTypeSingleEventFormFieldProps} from "../types";

export function LiveEventEventTypeTopicTypeSingleEventStartTimeFormField({
  formType,
}: {
  formType: LiveEventEventTypeTopicTypeSingleEventFormFieldProps["formType"];
}) {
  const {control, getValues} = useFormContext<LiveEventEventTypeFormFieldsType>();
  const defaultValue = getValues("startTime");
  const hasDefaultValue = formType === "edit";
  return (
    <div>
      <FormField
        id={"singleEventStartTime"}
        label={"Event time"}
        renderInput={(id) =>
          hasDefaultValue ? (
            <StyledInputValue>
              <p>{defaultValue}</p>
            </StyledInputValue>
          ) : (
            <Controller
              control={control}
              name="startTime"
              render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
                <Space size={16} direction="vertical" style={{display: "flex"}}>
                  <Select
                    id={id}
                    size="large"
                    status={error?.message ? "error" : undefined}
                    style={{width: "100%"}}
                    onChange={onChange}
                    value={value}
                    ref={ref}
                    onBlur={onBlur}
                    options={TIMEOPTIONS.map((to) => ({
                      label: to.name,
                      value: to.value,
                    }))}
                    placeholder={"9:00 AM"}
                  />
                  <FormFieldError errorMessage={error?.message} />
                </Space>
              )}
            />
          )
        }
      />
    </div>
  );
}
